import catoLogoUrl from '../../../assets/cato.svg?url';

const PHOTO_SIZE_IN_PIXELS = 256;

// The standard EICAR test string: harmless, but every virus scanner treats it as malware, so Connect rejects it.
// Kept in two halves and joined at runtime so scanners do not flag this source file.
const EICAR = ['X5O!P%@AP[4\\PZX54(P^)7CC)7}$EICAR', '-STANDARD-ANTIVIRUS-TEST-FILE!$H+H*'].join('');

const loadImage = (url: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error(`Could not load image ${url}`));
    image.src = url;
  });

const canvasToPng = (canvas: HTMLCanvasElement): Promise<Blob> =>
  new Promise((resolve, reject) => {
    canvas.toBlob(
      blob => (blob ? resolve(blob) : reject(new Error('Could not encode the photo fixture'))),
      'image/png'
    );
  });

// Connect only accepts raster images, so the Cato logo is drawn onto a canvas and sent as a PNG.
export const createPhotoFixture = async (): Promise<File> => {
  const canvas = document.createElement('canvas');
  canvas.width = PHOTO_SIZE_IN_PIXELS;
  canvas.height = PHOTO_SIZE_IN_PIXELS;
  canvas.getContext('2d')?.drawImage(await loadImage(catoLogoUrl), 0, 0, PHOTO_SIZE_IN_PIXELS, PHOTO_SIZE_IN_PIXELS);

  return new File([await canvasToPng(canvas)], 'cato-harness-photo.png', { type: 'image/png' });
};

export const createEicarFixture = (): File => new File([EICAR], 'cato-harness-eicar.txt', { type: 'text/plain' });
